import * as React from 'react';
import {
    AccordionDetails,
    AccordionSummary,
    Card,
    SxProps,
    Theme,
    Typography
} from '@mui/material';
import { supportCardStyle } from './SupportCard';
import { StyledAccordionContainer } from '../ConfigurePage.styles';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { FAQProps } from '../../lib/models/SupportModels';

const FAQ = ({ faqs }: FAQProps) => {
    const [expandedPanels, setExpandedPanels] = React.useState<string[]>([]);

    const handleChange = (isExpanded: boolean, panel: string) => {
        isExpanded
            ? setExpandedPanels((expandedPanels: string[]) => [
                  ...expandedPanels,
                  isExpanded ? panel : ''
              ])
            : setExpandedPanels((expandedPanels: string[]) =>
                  expandedPanels.filter((n: string) => !n.startsWith(panel))
              );
    };

    if (faqs.length === 0) {
        return (
            <Card sx={supportCardStyle}>
                <Typography variant={'h2'}>FAQ</Typography>
                <Typography variant={'h6'} sx={{ color: 'cardSubtitle.main' }}>
                    No Frequently Asked Questions yet
                </Typography>
            </Card>
        );
    } else {
        return (
            <>
                <Card sx={supportCardStyle}>
                    <Typography variant={'h2'}>FAQ</Typography>

                    {faqs.map((element) => (
                        <StyledAccordionContainer
                            sx={{
                                fontWeight: '600',
                                paddingBottom: '0.5rem',
                                lineHeight: '1.75rem',
                                margin: '0.438rem 0',
                                padding: '0'
                            }}
                            key={element.id}
                            expanded={
                                expandedPanels instanceof Array
                                    ? expandedPanels.includes(element.question)
                                    : false
                            }
                            elevation={0}
                            disableGutters={true}
                            onChange={(_: unknown, isExpanded: boolean) =>
                                handleChange(isExpanded, element.question)
                            }>
                            <AccordionSummary
                                expandIcon={
                                    expandedPanels.includes(element.question) ? (
                                        <RemoveIcon />
                                    ) : (
                                        <AddIcon />
                                    )
                                }
                                sx={{ padding: '0 0 0 0.5rem' }}>
                                <Typography variant={'h4'} sx={{ whiteSpace: 'pre-line' }}>
                                    {element.question}
                                </Typography>
                            </AccordionSummary>

                            <AccordionDetails sx={{ padding: '0' }}>
                                <Typography sx={answerStyle}>{element.answer}</Typography>
                            </AccordionDetails>
                        </StyledAccordionContainer>
                    ))}
                </Card>
            </>
        );
    }
};

const answerStyle: SxProps<Theme> = () => ({
    background: '#EFEFEF',
    fontSize: 15,
    fontWeight: '400',
    padding: '0.375rem 1rem 0.375rem 1.25rem',
    lineHeight: '1.75rem',
    whiteSpace: 'pre-line'
});

export default FAQ;
